import "./Available.module.css";
import Header from "@/reusable_sections/Header";
import FeaturedRentals from "./sections/FeaturedRentals";
import RentalApplicationFaq from "./sections/RentalApplicationFaq";
import InvestKcFooter from "@/reusable_sections/Footer";
export default function AvailablePage() {
  return <div>
      <Header />
      <FeaturedRentals />
      <RentalApplicationFaq />
      <InvestKcFooter />
    </div>;
}